import {
  ABHA_SEO_WIDGET,
  CHALLAN_WIDGET_LANDING,
  FASTAG_WIDGET_LANDING,
  HSRP_WIDGET_LANDING,
  RTO_WIDGET,
} from '@components/Product/ProductWidget/constants'
import { Visibility } from '@enums/Visibility'
import { isVasWidget } from '@helpers/vasLandingPageHelper'

export const DISABLE_USPS = ['car-seo-widget', 'bike-seo-widget']

export const NON_RESPONSIVE_WIDGET = ['health-seo-widget', 'life-seo-widget']
export const RESPONSIVE_WIDGET = [
  'travel-seo-widget',
  'travel-sem-widget',
  'car-seo-widget',
  'bike-seo-widget',
  'fastag-widget',
  'puc-widget',
  'abha-seo-widget',
  'multi-product-widget',
  'gmc-cta-widget',
  'health-cta-widget',
  'travel-cta-widget',
  'life-cta-widget',
  'rto-vehicle-info-widget',
  'rto-widget',
  'challan-widget',
  'challan-widget-landing-page',
  'fastag-widget-landing-page',
  'hsrp-widget-landing-page',
  'RTOWidget',
]

export const PRODUCT_WIDGETS_VS_BOTTOM_FLOATER_PROPS = ({ setShow }) => ({
  'travel-seo-widget': {
    isBottomFloater: true,
  },
  'travel-sem-widget': {
    isBottomFloater: true,
    showPhoneInput: false,
  },
  'health-seo-widget': {
    onHide: setShow,
    isBottomFloater: true,
    addScroll: true,
  },
  'life-seo-widget': {
    onHide: setShow,
    isBottomFloater: true,
    addScroll: true,
  },
  'car-seo-widget': {
    onHide: setShow,
    isBottomFloater: true,
  },
  'bike-seo-widget': {
    onHide: setShow,
    isBottomFloater: true,
  },
  'fastag-widget': {
    onHide: setShow,
    isBottomFloater: true,
  },
  'abha-seo-widget': {
    onHide: setShow,
    isBottomFloater: true,
  },
  'multi-product-widget': {
    onHide: setShow,
    isBottomFloater: true,
  },
  'gmc-cta-widget': {
    onHide: setShow,
    isBottomFloater: true,
  },
  'health-cta-widget': {
    onHide: setShow,
    isBottomFloater: true,
  },
  'travel-cta-widget': {
    onHide: setShow,
    isBottomFloater: true,
  },
  'life-cta-widget': {
    onHide: setShow,
    isBottomFloater: true,
  },
  'puc-widget': {
    onHide: setShow,
    isBottomFloater: true,
  },
  'rto-vehicle-info-widget': {
    onHide: setShow,
    isBottomFloater: true,
  },
  'rto-widget': {
    onHide: setShow,
    isBottomFloater: true,
  },
  'challan-widget': {
    onHide: setShow,
    isBottomFloater: true,
  },
  'challan-widget-landing-page': {
    onHide: setShow,
    isBottomFloater: true,
  },
  'fastag-widget-landing-page': {
    onHide: setShow,
    isBottomFloater: true,
  },
  'hsrp-widget-landing-page': {
    onHide: setShow,
    isBottomFloater: true,
  },
  RTOWidget: {
    onHide: setShow,
    isBottomFloater: true,
  },
})

export const REALTION_VS_RELATION_PROPS = ({ productGoogleRatingResponse }) => ({
  'relation.product-page-grw': productGoogleRatingResponse,
})

export const widgetsProductType = {
  'travel-seo-widget': 'Travel',
  'travel-sem-widget': 'Travel',
  'health-seo-widget': 'Health',
  'life-seo-widget': 'Life',
  'car-seo-widget': 'Car',
  'bike-seo-widget': 'Bike',
  'fastag-widget': 'Fastag',
  'puc-widget': 'puc',
  'abha-seo-widget': 'abha',
  'gmc-cta-widget': 'Gmc CTA',
  'health-cta-widget': 'Health CTA',
  'travel-cta-widget': 'Travel CTA',
  'life-cta-widget': 'Life CTA',
  'rto-vehicle-info-widget': 'rto vehicle info',
  'rto-widget': 'rto detail',
  'challan-widget': 'challan widget',
  'challan-widget-landing-page': 'challan landing widget',
  'fastag-widget-landing-page': 'fastag landing widget',
  'hsrp-widget-landing-page': 'hsrp landing widget',
  RTOWidget: 'rto widget',
}

export const RELATION_VS_COMPONENT_DATA = {
  'relation.product-page-author': content => content?.[0]?.attributes?.authorName?.data,
}

export const getAutoWidgetLayout = {
  'travel-seo-widget': false,
  'travel-sem-widget': false,
  'health-seo-widget': false,
  'life-seo-widget': false,
  'car-seo-widget': true,
  'bike-seo-widget': true,
  'fastag-widget': true,
  'abha-seo-widget': false,
  'multi-product-widget': true,
  'gmc-cta-widget': false,
  'health-cta-widget': false,
  'travel-cta-widget': false,
  'life-cta-widget': false,
  'puc-widget': true,
  'rto-vehicle-info-widget': true,
  'rto-widget': true,
  'challan-widget': true,
  'challan-widget-landing-page': true,
  'fastag-widget-landing-page': true,
  'hsrp-widget-landing-page': true,
  RTOWidget: true,
}

export const getpurpleRootContainerLayout = {
  'travel-seo-widget': false,
  'travel-sem-widget': false,
  'health-seo-widget': false,
  'life-seo-widget': false,
  'car-seo-widget': true,
  'bike-seo-widget': true,
  'fastag-widget': true,
  'puc-widget': true,
  'abha-seo-widget': true,
  'multi-product-widget': true,
  'gmc-cta-widget': true,
  'health-cta-widget': true,
  'travel-cta-widget': true,
  'life-cta-widget': true,
  'rto-vehicle-info-widget': true,
  'rto-widget': true,
  'challan-widget': true,
  'challan-widget-landing-page': true,
  'fastag-widget-landing-page': true,
  'hsrp-widget-landing-page': true,
  RTOWidget: true,
}

export const getHealthWidgetLayout = {
  'health-seo-widget': false,
  'abha-seo-widget': true,
  'multi-product-widget': false,
  'gmc-cta-widget': false,
  'health-cta-widget': false,
  'travel-cta-widget': false,
  'life-cta-widget': false,
}

export const getCtaWidgetPurpleLayout = {
  'abha-seo-widget': false,
  'gmc-cta-widget': true,
  'health-cta-widget': true,
  'travel-cta-widget': true,
  'life-cta-widget': true,
  'travel-seo-widget': false,
  'travel-sem-widget': false,
  'health-seo-widget': false,
  'life-seo-widget': false,
  'car-seo-widget': false,
  'bike-seo-widget': false,
  'fastag-widget': false,
  'puc-widget': false,
  'multi-product-widget': false,
  'rto-vehicle-info-widget': false,
  'rto-widget': false,
  'challan-widget': false,
}

export const replaceDivWithHeadingTags = {
  'fastag-widget': true,
  'multi-product-widget': true,
  'puc-widget': true,
  'rto-vehicle-info-widget': true,
  'rto-widget': true,
  'challan-widget': true,
  'challan-widget-landing-page': true,
  'fastag-widget-landing-page': true,
  'hsrp-widget-landing-page': true,
  RTOWidget: true,
}

export const shouldHideHeader = {
  'fastag-widget-landing-page': true,
  'hsrp-widget-landing-page': true,
}

export const HEADING_TAGS = {
  SEO_CAR_WIDGET: 'h1',
  HEALTH_WIDGET_PURPLE_LAYOUT: 'h1',
  DEFAULT: 'h2',
}

export const ContainerVisibility = {
  [Visibility.SHOW]: true,
  [Visibility.HIDE]: false,
}

export const widgetVisibilityConfig = {
  [ABHA_SEO_WIDGET]: ContainerVisibility,
  [CHALLAN_WIDGET_LANDING]: ContainerVisibility,
  [FASTAG_WIDGET_LANDING]: ContainerVisibility,
  [HSRP_WIDGET_LANDING]: ContainerVisibility,
  [RTO_WIDGET]: ContainerVisibility,
}

export const shouldDisplayWidget = (widgetType, isRightContainer) => {
  const isAbhaWidget = widgetType === ABHA_SEO_WIDGET
  const isVasLandingWidget = isVasWidget(widgetType)
  if (isVasLandingWidget) {
    return widgetVisibilityConfig[widgetType][isRightContainer ? Visibility.SHOW : Visibility.HIDE]
  }

  return isAbhaWidget
    ? widgetVisibilityConfig[ABHA_SEO_WIDGET][isRightContainer ? Visibility.SHOW : Visibility.HIDE]
    : !isRightContainer
}
